module.exports = ".test-scroll {\n  overflow-y: scroll !important;\n  height: 500px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/buyer/add-new-project/add-new-project.component.scss
// module id = ./src/app/buyer/add-new-project/add-new-project.component.scss
// module chunks = main